import instance from './api';

export const getServiceLogs = async () => {
  try {
    const response = await instance.get('admin/object/service/list');
    return response;
  } catch (error) {
    console.error('Error fetching service update count:', error);
    throw error;
  }
};

export const runExtendedTagsService = async (serviceId) => {
  try {
    const response = await instance.put('admin/object/service/extendedTags/run', {
      serviceId: serviceId
    });
    return response;
  } catch (error) {
    console.error('Error running extended tags service:', error);
    throw error;
  }
};

export const runUpdateCountService = async (serviceId) => {
  try {
    const response = await instance.put('admin/object/service/updateCount/run');
    return response;
  } catch (error) {
    console.error('Error running update count service:', error);
    throw error;
  }
};

export const runServiceDashboard = async (serviceKey,serviceId) => {
  try {
    const response = await instance.put(`admin/object/service/${serviceKey}/run`,{
      serviceId: serviceId
    });
    return response;
  } catch (error) {
    console.error('Error running service dashboard:', error);
    throw error;
  }
};